export default "__VITE_PUBLIC_ASSET__1057991e__"